import { render } from "./monthly.vue?vue&type=template&id=8aa332fc&scoped=true&ts=true"
import script from "./monthly.vue?vue&type=script&lang=ts"
export * from "./monthly.vue?vue&type=script&lang=ts"

import "./monthly.vue?vue&type=style&index=0&id=8aa332fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa332fc"]])

export default __exports__